import * as t from 'io-ts';
import { BasePostRequest } from 'acscp/api/requests/core/basePostRequest';
import { Authentication } from 'acscp/api/requests/core/baseRequest';

export class RequestVerificationTokenRequest extends BasePostRequest<undefined> {
    constructor(public email: string) {
        super(`users/request-verification`,
            {},
            {email},
            t.undefined,
            Authentication.None);
    }
}
